import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/advantages',
    name: 'advantages',
    component: () => import('../views/Advantages.vue')
  },
  {
    path: '/modulos',
    component: () => import('../views/Modules.vue'),
    children: [
      {
        path: 'elementos',
        name: 'elements',
        component: () => import('../views/Modules-elements.vue')
      },
      {
        path: 'materiales',
        name: 'materials',
        component: () => import('../views/Modules-materials.vue')
      },
      {
        path: 'alteraciones',
        name: 'alteraciones',
        component: () => import('../views/Modules-alteraciones.vue')
      },
      {
        path: 'fases',
        name: 'phases',
        component: () => import('../views/Modules-phases.vue')
      },
      { path: 'humedades',
        name: 'humidities',
        component: () => import('../views/Modules-humidities.vue')
      },
      {
        path: 'intervencion',
        name: 'intervention',
        component: () => import('../views/Modules-intervention.vue')
      },
      {
        path: 'mantenimiento',
        name: 'maintenance',
        component: () => import('../views/Modules-maintenance.vue')
      },
      {
        path: 'arqueología',
        name: 'archeology',
        component: () => import('../views/Modules-archeology.vue')
      },
      {
        path: 'deformacion',
        name: 'deformation',
        component: () => import('../views/Modules-deformation.vue')
      },
      {
        path: 'muestreo',
        name: 'sampling',
        component: () => import('../views/Modules-sampling')
      },
      {
        path: 'recubrimientos',
        name: 'coatings',
        component: () => import('../views/Modules-coatings')
      },
      {
        path: 'landmodules',
        name: 'landmodules',
        component: () => import('../views/LandModules.vue')
      },
      {
        path: '',
        name: 'homemodules',
        redirect: { name: 'landmodules' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
